<template>
  <fragment>
    <!-- Not expanded, parent visible: title entry with right arrow -->
    <el-menu-item v-show="expandedSubmenu === parentId" class="mobile-inline-submenu" @click="expand">
      <slot name="title"></slot>
      <i class="el-submenu__icon-arrow el-icon-arrow-right"></i>
    </el-menu-item>
    <!-- Expanded state: title entry with left arrow and entries -->
    <el-menu-item v-show="expandedSubmenu === submenuId" class="mobile-inline-submenu expanded" @click="collapse">
      <i class="el-submenu__icon-arrow el-icon-arrow-left"></i>
      <slot name="title"></slot>
    </el-menu-item>
    <slot name="entries"></slot>
  </fragment>
</template>

<script>
import authentication from '@/authentication';
import products from '@/components/products';
import mixins from '@/mixins';
import { mapState, mapGetters } from 'vuex';
import { Fragment } from 'vue-frag';

export default {
  name: 'NavMobileInlineSubmenu',
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
    submenuId: {
      type: String,
      required: true,
    },
    parentId: {
      type: String,
      required: false,
    },
    expandedSubmenu: {
      type: String,
      required: false,
    },
    expandedChanged: {
      type: Function,
      required: true,
    },
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(authentication.store.namespace, [
      'isLoggedIn'
    ]),
    ...mapState(products.store.namespace, [
      'categories'
    ]),
  },
  methods: {
    expand() {
      this.expandedChanged(this.submenuId);
    },
    collapse() {
      this.expandedChanged(this.parentId);
    },
  },
  components: {
    Fragment,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import '@/assets/base/_typography.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.mobile-inline-submenu {

  &.el-menu-item {
    @extend h4;
    font-family: $font-family-headings;
    line-height: 40px;
    color: $--color-secondary;
    padding-top: 8px;
    border-bottom: 1px solid $--color-grayscale-2 !important;

    &.expanded {
      // Important necessary because el-menu gets a "style" tag applied
      padding-left: 50px !important;
      padding-right: 0;
      color: $--color-primary;

      &:deep(.el-submenu__icon-arrow) {
        left: 20px;
        right: unset;
      }
    }

    &:focus-visible {
      text-decoration: underline;
    }
  }

  &:deep(.el-submenu__icon-arrow) {
    margin-top: -15px;
    font-size: 30px;
    color: $--color-primary;
  }
}
</style>
